module.exports = __webpack_public_path__ + "static/media/visa_mastercard.613a7888.jpg";